module.exports = __webpack_public_path__ + "img/dm.dmf17f9b3.svg";